<div
  class="modal-content"
  [id]="$safeNavigationMigration(modal?.settings?.['customID']?.value)"
  [class]="modal?.settings?.['customClasses']?.value"
>
  <button type="button" class="modal-close-button" (click)="closeModal()">
    &times;
  </button>
  <div class="modal-body">
    <div
      class="grid-container"
      [class.has-auto-height]="hasAutoHeightComponents()"
    >
      @for (component of getModalComponents(); track component) {
      <div
        class="grid-item"
        [attr.data-auto-height]="isAutoHeight(component) ? 'true' : null"
        [ngStyle]="{
          'grid-column':
            (component?.x || 0) + 1 + ' / span ' + (component?.cols || 1),
          'grid-row': isAutoHeight(component)
            ? (component?.y || 0) + 1 + ' / auto'
            : (component?.y || 0) + 1 + ' / span ' + (component?.rows || 1)
        }"
        [id]="
          component.settings && component.settings['customID']
            ? component.settings['customID'].value
            : null
        "
        [class]="
          component.settings && component.settings['customClasses']
            ? component.settings['customClasses'].value
            : null
        "
      >
        <app-dynamic-component
          [customComponent]="component"
          [editorMode]="false"
        >
        </app-dynamic-component>
      </div>
      }
    </div>
  </div>
</div>
